var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconDownload = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 18 18"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#EF5A5E"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.989 13.087v3.979c0 .08-.012.153-.029.22a.854.854 0 01-.832.686H.866a.852.852 0 01-.843-.759c-.012-.05-.012-.096-.012-.153v-3.979c0-.47.385-.849.85-.849a.852.852 0 01.848.85v3.186h14.587V13.08c0-.47.385-.849.85-.849.231 0 .446.096.6.25a.897.897 0 01.243.605z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.896 9.102l-4.171 4.172c-.006.01-.017.017-.023.022a.983.983 0 01-.55.278c-.016 0-.033.005-.05.005-.034.006-.068.006-.102.006l-.096-.006c-.017 0-.034-.005-.051-.005a.965.965 0 01-.55-.278l-.022-.022L4.11 9.102a.99.99 0 01-.288-.702.99.99 0 011.692-.702l2.508 2.508V1.019c0-.544.447-.99.99-.99.272 0 .521.113.702.288a.979.979 0 01.289.702v9.187l2.507-2.508a.998.998 0 011.404 0c.368.39.368 1.019-.017 1.404z"
}))));

export default SvgIconDownload;